<template>
  <basic-container id="carcouponused20220323">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="parkingLotIdSearch">
        <selectSearch  v-model="parkingLotId" :dicData="spaceList"  @change="parkingLotQueryChanged"></selectSearch>
        <!-- <el-select
          v-model="parkingLotId"
          filterable
          @change="parkingLotQueryChanged"
          style="width: 100%"
          placeholder="车场名称"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select> -->
      </template>
      <template slot-scope="scope" slot="shopIdSearch">
        <el-select v-model="shopId" filterable style="width: 100%" placeholder="商家名称">
          <el-option
            v-for="item in shopList"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="collectTimeRangeSearch">
        <div style="display: flex;">
                              <el-date-picker
                                    style="width:42%;"
                                    v-model="collectTimeStart"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="到"
                                    placeholder="开始日期"
                                
                                  >
                                  </el-date-picker>
                                  到
                                  <el-date-picker
                                    style="width:42%;"
                                    v-model="collectTimeEnd"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    
                                  
                                    placeholder="结束日期"
                                  >
                                  </el-date-picker>
                            </div>
        <!-- <el-date-picker
          v-model="collectTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker> -->
      </template>
      <template slot-scope="scope" slot="useTimeRangeSearch">
        <div style="display: flex;">
                              <el-date-picker
                                    style="width:42%;"
                                    v-model="useTimeFrom"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="到"
                                    placeholder="开始日期"
                                
                                  >
                                  </el-date-picker>
                                  到
                                  <el-date-picker
                                    style="width:42%;"
                                    v-model="useTimeTo"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    
                                  
                                    placeholder="结束日期"
                                  >
                                  </el-date-picker>
                            </div>
      </template>
      <template slot-scope="scope" slot="totalDiscountAmountSearch" id="totalDiscountAmount">
        <el-input
          v-model="totalDiscountAmount"
          disabled="true"
          placeholder="0"
          style="width: 100%"
        ></el-input>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carcouponused_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getDiscountAmount,
} from '@/api/v4ward/park/couponv2/used/carcouponused';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { shopList } from '@/api/v4ward/park/couponv2/shop/carcouponshop';
import func from '@/util/func';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      collectTimeStart:'',
      collectTimeEnd:'',
      useTimeFrom:'',
      useTimeTo:'',
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 55,
        searchLabelWidth: 120,
        tip: false,
        searchShow: true,
        span: 6,
        searchMenuSpan: 24,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'left',
        indexLabel: '#',
        menu: false,
        columnBtn: true,
        refreshBtn: true,
        emptyBtn: true,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchslot: true,
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商家名称',
            prop: 'shopId',
            hide: true,
            type: 'select',
            display: false,
            searchSpan: 6,
            search: true,
            showColumn: false,
            searchslot: true,
            rules: [
              {
                required: true,
                message: '请输入结算商家id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商家名称',
            prop: 'shopName',
            overHidden: true,
          },
          {
            label: '领用时间',
            prop: 'collectTimeRange',
            search: true,
            searchSpan: 12,
            showColumn: false,
            searchslot: true,
            hide: true,
            display: false,
          },
          {
            label: '使用时间',
            prop: 'useTimeRange',
            search: true,
            searchSpan: 12,
            showColumn: false,
            searchslot: true,
            hide: true,
            display: false,
          },
          {
            label: '优惠券名称',
            prop: 'couponName',
            overHidden: true,
            search: true,
            searchSpan: 6,
          },
          {
            label: '优惠券类型',
            prop: 'couponTypeName',
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            search: true,
            searchSpan: 6,
          },
          {
            label: '领用时间',
            prop: 'collectTime',
          },
          {
            label: '优惠券是否使用',
            prop: 'balancedStatus',
            type: 'select',
            search: true,
            searchSpan: 6,
            dicData: [
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '优惠金额',
            prop: 'totalDiscountAmount',
            search: true,
            showColumn: false,
            searchslot: true,
            searchSpan: 6,
            hide: true,
            display: false,
          },
          {
            label: '优惠券过期时间',
            prop: 'couponExpireDate',
          },
          {
            label: '使用时间',
            prop: 'couponUsedTime',
            rules: [
              {
                required: true,
                message: '请输入优惠券使用时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠金额',
            align: 'right',
            prop: 'discountAmount',
          },
          /*{
              label: '支付信息',
              prop: 'payInfo',
              overHidden: true,
            },*/
        ],
      },
      data: [],
      spaceList: [],
      shopList: [],
      shopId: '',
      parkingLotId: '',
      firstDisplayFlag: true,
      useTimeRange: '',
      collectTimeRange: '',
      totalDiscountAmount: 0,
    };
  },
  created() {
    this.initTimeRange();
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        // 默认查询第一个
        this.parkingLotId = this.spaceList[0].id;
        this.initShopList(this.parkingLotId);
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
    });
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carcouponused_add, false),
        viewBtn: this.vaildData(this.permission.carcouponused_view, false),
        delBtn: this.vaildData(this.permission.carcouponused_delete, false),
        editBtn: this.vaildData(this.permission.carcouponused_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    initTimeRange() {
      this.collectTimeStart=func.getCurrentMonthFirst() + ' 00:00:00';
        this.collectTimeEnd=func.getCurrentMonthLast() + ' 23:59:59';
    },
    initShopList(parkingLotId) {
      shopList({ parkingLotId: parkingLotId, byShopUser: 1 }).then((data) => {
        this.shopList = data.data;
        if (this.shopList.length > 0) {
          var shopColumn = this.findObject(this.option.column, 'shopId');
          //shopColumn.searchValue = this.shopList[0].id;
          this.shopId = this.shopList[0].id;
          this.onLoad();
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.shopId = '';
          this.onLoad();
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
      });
    },
    parkingLotQueryChanged(value) {
      this.initShopList(value);
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else if ('add' === type) {
        this.cleanForm();
      }
      done();
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = null;
      }
    },
    searchReset() {
      this.query = {};
      this.useTimeRange = '';
      this.useTimeFrom=''
        this.useTimeTo=''
      this.collectTimeStart=func.getCurrentMonthFirst() + ' 00:00:00';
        this.collectTimeEnd=func.getCurrentMonthLast() + ' 23:59:59';
    
      if (this.shopList.length > 0) {
        this.shopId = this.shopList[0].id;
      } else {
        this.shopId = '';
      }
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      this.loading = false;
      page = page || this.page;
      this.query.parkingLotId = this.parkingLotId;
      if (this.vdui.isEmpty(this.query.parkingLotId)) {
        return;
      }
      this.loading = true;
     
      this.query.useTimeTo=this.useTimeTo
      this.query.useTimeFrom=this.useTimeFrom
      this.query.collectTimeStart = this.collectTimeStart;
        this.query.collectTimeEnd = this.collectTimeEnd;
      
      this.query.shopId = null;
      if (this.vdui.isNotEmpty(this.shopId)) {
        this.query.shopId = this.shopId;
      }
      if (this.shopList.length == 0) {
        this.query.shopId = null;
      }
      if (this.vdui.isNotEmpty(this.query.plateNumber)) {
        this.query.plateNumber = this.query.plateNumber.trim().replace(' ', '');
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();

          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            this.firstDisplayFlag = false;
          }
        }
      );
      getDiscountAmount(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
      ).then(({ data }) => {
        this.totalDiscountAmount = data;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
